module.exports = __webpack_public_path__ + "img/avatar7.0cc4ff39.png";